const domaine = 'DONNEES_PERSONNELLES'

export const AJOUTER_FORMULAIRE_DONNEES_PERSONNELLES = `${domaine}/AJOUTER_FORMULAIRE_DONNEES_PERSONNELLES`
